// extracted by mini-css-extract-plugin
export default {"contenedorEstado":"Estilos_contenedorEstado__pe99O","titulo":"Estilos_titulo__2MGwe","icono":"Estilos_icono__3up8T","info":"Estilos_info__+A-po"};